/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Info } from '../fn/health-check/info';
import { Info$Params } from '../fn/health-check/info';
import { MiniProfilerIncludes } from '../fn/health-check/mini-profiler-includes';
import { MiniProfilerIncludes$Params } from '../fn/health-check/mini-profiler-includes';
import { MiniProfilerText } from '../fn/health-check/mini-profiler-text';
import { MiniProfilerText$Params } from '../fn/health-check/mini-profiler-text';
import { Ping } from '../fn/health-check/ping';
import { Ping$Params } from '../fn/health-check/ping';
import { Status } from '../fn/health-check/status';
import { Status$Params } from '../fn/health-check/status';
import { SystemStatus } from '../models/system-status';

@Injectable({ providedIn: 'root' })
export class HealthCheckApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHealthCheckPingGet()` */
  static readonly ApiHealthCheckPingGetPath = '/api/HealthCheck/Ping';

  /**
   * Reuturns a 200 OK  "pong" response to indicate the service is running.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Ping()` instead.
   *
   * This method doesn't expect any request body.
   */
  Ping$Response(params?: Ping$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Ping(this.http, this.rootUrl, params, context);
  }

  /**
   * Reuturns a 200 OK  "pong" response to indicate the service is running.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Ping$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Ping(params?: Ping$Params, context?: HttpContext): Observable<void> {
    return this.Ping$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckInfoGet()` */
  static readonly ApiHealthCheckInfoGetPath = '/api/HealthCheck/Info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Info()` instead.
   *
   * This method doesn't expect any request body.
   */
  Info$Response(params?: Info$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Info(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Info$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Info(params?: Info$Params, context?: HttpContext): Observable<void> {
    return this.Info$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckMiniProfilerIncludesGet()` */
  static readonly ApiHealthCheckMiniProfilerIncludesGetPath = '/api/HealthCheck/MiniProfilerIncludes';

  /**
   * Return the MiniProfiler includes for the current request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MiniProfilerIncludes()` instead.
   *
   * This method doesn't expect any request body.
   */
  MiniProfilerIncludes$Response(params?: MiniProfilerIncludes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MiniProfilerIncludes(this.http, this.rootUrl, params, context);
  }

  /**
   * Return the MiniProfiler includes for the current request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MiniProfilerIncludes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MiniProfilerIncludes(params?: MiniProfilerIncludes$Params, context?: HttpContext): Observable<void> {
    return this.MiniProfilerIncludes$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckMiniProfilerTextGet()` */
  static readonly ApiHealthCheckMiniProfilerTextGetPath = '/api/HealthCheck/MiniProfilerText';

  /**
   * Return the MiniProfiler text for the current request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MiniProfilerText()` instead.
   *
   * This method doesn't expect any request body.
   */
  MiniProfilerText$Response(params?: MiniProfilerText$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MiniProfilerText(this.http, this.rootUrl, params, context);
  }

  /**
   * Return the MiniProfiler text for the current request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MiniProfilerText$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MiniProfilerText(params?: MiniProfilerText$Params, context?: HttpContext): Observable<void> {
    return this.MiniProfilerText$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHealthCheckStatusGet()` */
  static readonly ApiHealthCheckStatusGetPath = '/api/HealthCheck/Status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Status()` instead.
   *
   * This method doesn't expect any request body.
   */
  Status$Response(params?: Status$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemStatus>> {
    return Status(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Status$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Status(params?: Status$Params, context?: HttpContext): Observable<SystemStatus> {
    return this.Status$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemStatus>): SystemStatus => r.body)
    );
  }

}
